import React, { useEffect, useState } from "react";
import { Card, Tag, Divider, Badge } from "antd";
import {
  UserOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  ClusterOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../Common/APIConstants";
import dayjs from "dayjs";

export default function LicenseDetails() {
    const { loading, makeRequest } = useStoreUpdaterWithAPI();
    const [license,setLicense]=useState([])
  const licenseData = {
    clientName: "ABC Industries Pvt. Ltd.",
    gateways: 5,
    meters: 120,
    modules: ["Electrical", "Water", "Air", "Gas"],
    startDate: "01/01/2025",
    endDate: "31/12/2025",
    licenseStatus: "Active",
  };

    const getLicenseDetails = () => {
      // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
      const url = `${APIConstants.GET_LICENSE_DETAILS}/1`;
      //console.log(url);
  
      makeRequest({
        type: APIConstants.GET,
        url: url,
      }).then((res) => {
        console.log(res);
        if (res) {
          console.log(res)
          setLicense(res[0]);
        }
      });
    };
      useEffect(() => {
        getLicenseDetails();
      }, []);
      console.log(license)
  return (
    <div className="p-8 bg-gradient-to-br from-gray-50 to-gray-200 h-screen flex flex-col gap-6">
      
      {/* Page Title */}
      <div className="text-4xl font-semibold tracking-wide text-gray-800">
        🔐 License Details
      </div>

      {/* Center content */}
      <div className="flex justify-center items-center w-full">
        <Card
          hoverable
          className="w-full max-w-4xl shadow-2xl rounded-2xl border border-gray-300 bg-white"
          title={
            <div className="flex justify-between items-center">
              <span className="text-xl font-semibold">License Information</span>
              <Badge 
                status={"success"} 
                // status={license.licenseStatus === "Active" ? "success" : "error"} 
                text={"Active"}
                className="text-lg" 
              />
            </div>
          }
        >
          <div className="space-y-5 text-lg text-gray-700">
            
            {/* Client Name */}
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2 font-medium">
                <UserOutlined className="text-blue-500" />
                Client Name:
              </div>
              <span className="font-semibold">{license.ClientName}</span>
            </div>

            <Divider />

            {/* Gateways */}
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2 font-medium">
                <ClusterOutlined className="text-purple-600" />
                Number of Gateways:
              </div>
              <span className="font-semibold">{license.NoOfGateWays}</span>
            </div>

            {/* Meters */}
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2 font-medium">
                <DashboardOutlined className="text-green-600" />
                Number of Meters:
              </div>
              <span className="font-semibold">{license.NoOfMeters}</span>
            </div>

            <Divider />

            {/* Modules */}
            <div>
              <div className="flex items-center gap-2 font-medium mb-2">
                <AppstoreOutlined className="text-orange-600" />
                Modules Included:
              </div>

              <div className="flex flex-wrap gap-2">
    {license?.Modules
    ?.split(",")
    .map((module, index) => (
      <Tag key={index} color="blue" className="text-md px-3 py-1 rounded-lg">
        {module.trim()}
      </Tag>
    ))}
  </div>
            </div>

            <Divider />

            {/* License Duration */}
            <div className="flex justify-between">
              <div className="flex items-center gap-2 font-medium">
                <CalendarOutlined className="text-red-500" />
                Validity Period
              </div>
              <span className="font-semibold">
                {dayjs(license.StartDate).format("YYYY-MM-DD")} → {dayjs(license.EndDate).format("YYYY-MM-DD")}
              </span>
            </div>

          </div>
        </Card>
      </div>
    </div>
  );
}
